var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row main-header flex-center text-upper"},[(_vm.hasLogoSource)?_c('logo'):_vm._e(),_c('span',[_vm._v(_vm._s(_vm._f("translate")('live_v2.live_betting_header')))]),_c('clock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }